/* Pantallas interiores del prototipo (Diseño B) con cabecera y pie del tema (10/10/2026): compra en la
   ficha, galería, pestañas, «¿Es compatible con su impresora?», «Consumibles por modelo», orden y
   «Ajustar a N» del carrito. Sin dependencias propias: para avisar al carrito de Horizon (contador y
   cajón) se usa el módulo estándar '@shopify/events' del mapa de importación del tema. Datos: índice litoff.b_indice que calcula el servidor
   cada día (/opt/eet/shopify/disenob_datos.py), SOLO con productos publicados. El Liquid lo vuelca ya concatenado en el JSON
   de cada bloque; desde el formato 2 (24/10/2026) trae `cdn` (prefijo de las imágenes relativas `i`) y las impresoras llevan
   los datos sueltos (an, rs, tc, cx, ca) en vez de los chips `c`, que aquí se recomponen (función chips).
   Precios: sin IVA destacado y total con IVA aparte (mismo marcado que snippets/lo-precio). */
(function () {
  'use strict';
  var IVA = 21;
  var doc = document;

  function guarda(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } }
  function lee(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function euros(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + ' €';
  }
  function neto(bruto) { return Math.round(bruto * 100 / (100 + IVA)); }
  function json(id) {
    var el = doc.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function precioHTML(bruto, uds) {
    uds = uds > 1 ? uds : 1;
    var n = neto(bruto), nUd = Math.round(n / uds);
    return '<span class="lo-precio lo-precio--tarjeta">' +
      '<span class="lo-precio__principal price"><bdi>' + euros(n) + '</bdi> <span class="lo-precio__por">/ ' + (uds > 1 ? 'pack de ' + uds + ' uds' : 'unidad') + '</span></span>' +
      (uds > 1 ? '<span class="lo-precio__per"><bdi>' + euros(nUd) + '</bdi> por ud. · pack de ' + uds + ' uds</span>' : '') +
      '<span class="lo-precio__tax">Precio sin IVA</span>' +
      '<span class="lo-precio__secundario"><bdi>' + euros(bruto) + '</bdi> con IVA incl.</span></span>';
  }
  var PLAZOS = {
    '24_48h': ['Entrega 24–48 h', 'ok'], '4_5d': ['Entrega 4–5 días', 'ok'],
    remoto: ['Bajo pedido', 'espera'], entrada: ['Próxima entrada', 'espera']
  };
  var ICO = {
    camion: '<svg class="lob-ico" aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>',
    caja: '<svg class="lob-ico" aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h18v4H3zM5 11v9h14v-9M10 15h4"/></svg>'
  };
  /* Imagen del índice: ruta relativa al CDN (formato 2) o URL completa (formato 1 / fuera del CDN) */
  function imagen(i, cdn) {
    if (!i) return '';
    i = String(i).split('?')[0];
    return i.indexOf('//') === -1 ? (cdn || '') + i : i;
  }
  /* Chips de una impresora: los del índice (formato 1, `c`) o recompuestos con los datos sueltos (formato 2) */
  function chips(i) {
    if (i.c) return i.c;
    return [i.an ? 'Ancho ' + i.an : '', i.rs || '', (i.tc || []).join(' + '), i.ca ? 'Casete ' + i.ca : ''].filter(Boolean);
  }
  /* Mismo marcado que snippets/lob-tarjeta.liquid */
  function tarjeta(d, nota, cdn) {
    var pl = PLAZOS[d.pl] || ['Consultar plazo', 'gris'];
    var img = imagen(d.i, cdn);
    return '<article class="lob-card"><a class="lob-card__img" href="/products/' + esc(d.h) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(img) + '?width=360" srcset="' + esc(img) + '?width=240 240w, ' + esc(img) + '?width=360 360w, ' + esc(img) + '?width=480 480w" sizes="(min-width: 990px) 280px, 45vw" width="360" height="360" loading="lazy" alt="">' : '') +
      '</a><div class="lob-card__cuerpo"><p class="lob-card__marca">' + esc(d.m) + '</p>' +
      '<h3 class="lob-card__titulo"><a href="/products/' + esc(d.h) + '">' + esc(d.t) + '</a></h3>' +
      (d.r ? '<p class="lob-card__ref">Ref. ' + esc(d.r) + '</p>' : '') +
      '<p class="lob-chips"><span class="lob-chip lob-chip--' + pl[1] + '">' + ICO.camion + pl[0] + '</span>' +
      ((d.pk || 1) > 1 ? '<span class="lob-chip lob-chip--info">' + ICO.caja + 'Pack de ' + d.pk + ' uds</span>' : '') + '</p>' +
      (nota ? '<p class="lob-card__nota">' + esc(nota) + '</p>' : '') +
      '<div class="lob-card__precio">' + (d.p ? precioHTML(d.p, d.pk || 1) : '') + '</div></div></article>';
  }

  /* ---------------- ficha: pestañas (anclas) ---------------- */
  function initTabs(raiz) {
    var tabs = raiz.querySelectorAll('[data-lob-tab]');
    tabs.forEach(function (a) {
      a.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-current', x === a ? 'true' : 'false'); });
      });
    });
  }

  /* ---------------- ¿Es compatible con su impresora? ---------------- */
  function initCompat(raiz) {
    var d = json(raiz.getAttribute('data-lob-compat'));
    if (!d) return;
    var selM = raiz.querySelector('[data-lob-marca]'), selI = raiz.querySelector('[data-lob-imp]');
    var res = raiz.querySelector('[data-lob-res]');
    var marcas = [];
    d.imp.forEach(function (i) { if (marcas.indexOf(i.m) === -1) marcas.push(i.m); });
    marcas.sort();
    selM.innerHTML = '<option value="">Elija marca</option>' + marcas.map(function (m) { return '<option>' + esc(m) + '</option>'; }).join('');
    function modelos() {
      var m = selM.value;
      var lst = d.imp.filter(function (i) { return i.m === m; });
      selI.innerHTML = '<option value="">' + (m ? 'Elija modelo' : '—') + '</option>' +
        lst.map(function (i) { return '<option value="' + esc(i.h) + '">' + esc(i.n) + (i.s && i.s !== i.n ? ' · ' + esc(i.s) : '') + '</option>'; }).join('');
      selI.disabled = !m;
      res.hidden = true;
    }
    function evalua() {
      var h = selI.value;
      if (!h) { res.hidden = true; return; }
      var imp = d.imp.filter(function (i) { return i.h === h; })[0];
      var motivo = d.compat[h];
      guarda('lob-mi-impresora', h);
      if (motivo) {
        res.className = 'lob-compat__res lob-compat__res--ok';
        res.innerHTML = '<span aria-hidden="true">✓</span><span><strong>Compatible con ' + esc(imp.m + ' ' + imp.n) + '</strong><br>' + esc(motivo) + '</span>';
      } else {
        res.className = 'lob-compat__res lob-compat__res--no';
        res.innerHTML = '<span aria-hidden="true">?</span><span><strong>No podemos confirmarlo con los datos del fabricante.</strong><br>' +
          'Puede que sea compatible, pero no lo afirmamos sin comprobarlo. <a href="' + esc(d.contacto) + '">Consúltenos</a> y se lo confirmamos.</span>';
      }
      res.hidden = false;
    }
    selM.addEventListener('change', modelos);
    selI.addEventListener('change', evalua);
    var mia = lee('lob-mi-impresora');
    var pre = d.imp.filter(function (i) { return i.h === mia; })[0];
    if (pre) { selM.value = pre.m; modelos(); selI.value = pre.h; evalua(); } else { modelos(); }
  }

  /* ---------------- Consumibles por modelo ---------------- */
  function initCxm(raiz) {
    var d = json(raiz.getAttribute('data-lob-cxm'));
    if (!d || !d.imp) return;
    var cdn = d.cdn || '';
    var paso1 = raiz.querySelector('[data-paso=marca]'), paso2 = raiz.querySelector('[data-paso=serie]'), paso3 = raiz.querySelector('[data-paso=modelo]');
    var salida = raiz.querySelector('[data-lob-cxm-salida]');
    var estado = { m: '', s: '', h: '' };
    var GRUPOS = [
      ['cin', 'Cintas y casetes', 'Cintas en casete para rotuladoras e impresoras de etiquetas.'],
      ['etq', 'Etiquetas', 'Rollos y etiquetas precortadas.'],
      ['rib', 'Ribbons', 'Cintas de transferencia térmica.']
    ];
    function unicos(arr) { var o = []; arr.forEach(function (x) { if (o.indexOf(x) === -1) o.push(x); }); return o; }
    function pastillas(cont, vals, actual, clave, etiquetas) {
      if (!vals.length) { cont.innerHTML = '<p class="lob-paso__vacio">Elija primero el paso anterior.</p>'; return; }
      cont.innerHTML = '<ul class="lob-pastillas" role="list">' + vals.map(function (v, i) {
        return '<li><button type="button" class="lob-pastilla' + (v === actual ? ' is-activa' : '') + '" aria-pressed="' + (v === actual) + '" data-' + clave + '="' + esc(v) + '">' +
          esc(etiquetas ? etiquetas[i] : v) + '</button></li>';
      }).join('') + '</ul>';
    }
    function pinta() {
      if (!d.imp.length) {
        paso1.innerHTML = '<p class="lob-paso__vacio">Todavía no hay impresoras publicadas con datos suficientes.</p>';
        paso2.innerHTML = paso3.innerHTML = '';
        salida.innerHTML = '<div class="lob-cxm__aviso"><a href="' + esc(d.contacto) + '">Escríbanos con el modelo de su impresora</a> y le indicamos los consumibles adecuados.</div>';
        return;
      }
      var marcas = unicos(d.imp.map(function (i) { return i.m; })).sort();
      pastillas(paso1, marcas, estado.m, 'm');
      var deMarca = d.imp.filter(function (i) { return i.m === estado.m; });
      pastillas(paso2, unicos(deMarca.map(function (i) { return i.s; })).sort(), estado.s, 's');
      var deSerie = deMarca.filter(function (i) { return i.s === estado.s; });
      pastillas(paso3, deSerie.map(function (i) { return i.h; }), estado.h, 'h', deSerie.map(function (i) { return i.n + ((i.k && i.k.length) || i.kt ? '' : ' ·?'); }));
      var imp = d.imp.filter(function (i) { return i.h === estado.h; })[0];
      if (!imp) { salida.innerHTML = ''; return; }
      var html = '<div class="lob-cxm__imp">' + (imp.i ? '<img src="' + esc(imagen(imp.i, cdn)) + '?width=160" alt="" width="72" height="72">' : '<span></span>') +
        '<div><h2>' + esc(imp.m + ' ' + imp.n) + (imp.te ? ' · ' + esc(imp.te.toLowerCase()) : '') + '</h2><p class="lob-chips">' +
        chips(imp).map(function (c) { return '<span class="lob-chip lob-chip--gris">' + esc(c) + '</span>'; }).join('') + '</p></div>' +
        '<button type="button" class="lob-btn lob-btn--sec" data-lob-guardar>' + (lee('lob-mi-impresora') === imp.h ? 'Guardada como «Mi impresora»' : 'Guardar como «Mi impresora»') + '</button></div>';
      var ks = imp.k || [];
      if (!ks.length && imp.kt > 0) {
        html += '<div class="lob-cxm__aviso">Hemos calculado ' + imp.kt + (imp.kt === 1 ? ' consumible compatible' : ' consumibles compatibles') + ' con este modelo según los datos del fabricante, pero todavía no están publicados en la tienda. ' +
          '<a href="' + esc(d.contacto.split('#')[0]) + '&producto=' + encodeURIComponent(imp.h) + '#form-contacto">Consúltenos</a> y le indicamos cuáles le sirven, con su precio y su plazo.</div>';
      } else if (!ks.length) {
        html += '<div class="lob-cxm__aviso">Para este modelo todavía no podemos calcular la compatibilidad con los datos del fabricante (faltan datos de ancho, mandril o tipo de consumible). ' +
          '<a href="' + esc(d.contacto.split('#')[0]) + '&producto=' + encodeURIComponent(imp.h) + '#form-contacto">Consúltenos</a> y le indicamos los consumibles adecuados.</div>';
      }
      GRUPOS.forEach(function (g) {
        var items = ks.map(function (k) { return d.con[k]; }).filter(function (c) { return c && c.ty === g[0]; });
        if (!items.length) return;
        html += '<section class="lob-bloque lob-cxm__grupo"><h2 class="lob-h2">' + g[1] + ' <small>' + items.length + ' compatibles</small></h2>' +
          '<p class="lob-bloque__sub">' + g[2] + '</p><div class="lob-rejilla lob-rejilla--4">' +
          items.slice(0, 12).map(function (c) { return tarjeta(c, c.a ? 'Ancho ' + c.a : '', cdn); }).join('') + '</div>' +
          (items.length > 12 ? '<p class="lob-nota">Se muestran 12 de ' + items.length + '. <a href="/search?q=' + encodeURIComponent(imp.n) + '">Ver todos</a></p>' : '') + '</section>';
      });
      html += '<div class="lob-cxm__aviso"><strong>¿Necesita otra medida o material?</strong> LIT-OFF le suministra etiquetas a medida para su impresora (papel, polipropileno, poliéster, alta temperatura). ' +
        '<a href="' + esc(d.medida) + '">Pida presupuesto</a>.</div>';
      salida.innerHTML = html;
    }
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !raiz.contains(b)) return;
      if (b.hasAttribute('data-m')) { estado = { m: b.getAttribute('data-m'), s: '', h: '' }; var s = unicos(d.imp.filter(function (i) { return i.m === estado.m; }).map(function (i) { return i.s; })); if (s.length === 1) estado.s = s[0]; }
      else if (b.hasAttribute('data-s')) { estado.s = b.getAttribute('data-s'); estado.h = ''; var h = d.imp.filter(function (i) { return i.m === estado.m && i.s === estado.s; }); if (h.length === 1) estado.h = h[0].h; }
      else if (b.hasAttribute('data-h')) { estado.h = b.getAttribute('data-h'); }
      else if (b.hasAttribute('data-lob-guardar')) { guarda('lob-mi-impresora', estado.h); b.textContent = 'Guardada como «Mi impresora»'; return; }
      else return;
      pinta();
      if (estado.h && window.history && history.replaceState) {
        try { history.replaceState(null, '', location.pathname + '?modelo=' + encodeURIComponent(estado.h)); } catch (err) { /* nada */ }
      }
    });
    var q = new URLSearchParams(location.search).get('modelo') || raiz.getAttribute('data-inicial') || lee('lob-mi-impresora');
    var ini = d.imp.filter(function (i) { return i.h === q; })[0];
    if (ini) estado = { m: ini.m, s: ini.s, h: ini.h };
    else if (d.imp.length === 1) estado = { m: d.imp[0].m, s: d.imp[0].s, h: d.imp[0].h };
    pinta();
  }


  /* ---------------- ficha: cantidad, galería y añadir al carrito ---------------- */
  function anade(form, variantId, cantidad) {
    // Mismo contrato que product-form.js de Horizon: evento CartLinesUpdateEvent + HTML de las secciones
    // del carrito (cajón y página) en detail.sections, para que se repinten y se abra el cajón.
    var ids = [];
    doc.querySelectorAll('cart-items-component').forEach(function (c) {
      var s = c.dataset && c.dataset.sectionId;
      if (s && ids.indexOf(s) === -1) ids.push(s);
    });
    var ev = null, diferida = null;
    // '@shopify/events' lo carga la ficha como módulo (window.lomEventos); import() solo de respaldo.
    var cargar = window.lomEventos ? Promise.resolve(window.lomEventos) : import('@shopify/events');
    var aviso = cargar.then(function (m) {
      ev = m;
      diferida = m.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new m.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: cantidad }],
        promise: diferida.promise
      }));
    }).catch(function (e) { if (window.console) console.warn('[lom] sin eventos del carrito', e); });
    var cuerpo = { items: [{ id: Number(variantId), quantity: cantidad }] };
    if (ids.length) { cuerpo.sections = ids.join(','); cuerpo.sections_url = location.pathname; }
    var resp = null;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        // Error REAL de Shopify (422, etc.): se muestra tal cual, nunca «Añadido».
        if (!r.ok || j.status) throw new Error(j.description || j.message || ('HTTP ' + r.status));
        resp = j; return j;
      });
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        aviso.then(function () {
          if (ev && diferida) diferida.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'lob-ficha', itemCount: cantidad, sections: resp && resp.sections, didError: false }
          });
        });
        return cart;
      });
    }).catch(function (err) {
      // Shopify puede haber añadido parte (p. ej. hasta el stock) aunque responda con error: se repintan el
      // cajón y el contador con el carrito REAL y se muestra igualmente el aviso de Shopify.
      var url = '/?sections=' + encodeURIComponent(ids.join(','));
      return Promise.all([
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        ids.length ? fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null)
      ]).then(function (res) {
        return aviso.then(function () {
          if (ev && diferida) diferida.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(res[0]),
            detail: { items: res[0].items, source: 'lob-ficha', itemCount: 0, sections: res[1] || undefined, didError: true }
          });
        });
      }, function () { return aviso.then(function () { if (diferida) diferida.reject(err); }); })
        .then(function () { throw err; });
    });
  }

  function initFicha(raiz) {
    var inp = raiz.querySelector('[data-lob-cant]');
    raiz.querySelectorAll('[data-lob-mas],[data-lob-menos]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(inp.value, 10) || 1) + (b.hasAttribute('data-lob-mas') ? 1 : -1);
        inp.value = Math.max(1, v);
        inp.dispatchEvent(new Event('change'));
      });
    });
    var txt = raiz.querySelector('[data-lob-btn-txt]');
    var mas = raiz.querySelector('[data-lob-mas]');
    // Stock limitado: máximo = stock - lo que ya hay en el carrito; + desactivado al llegar
    function maximo() { var m = parseInt(inp && inp.getAttribute('max'), 10); return isNaN(m) ? Infinity : m; }
    function limita() {
      if (!inp) return;
      var m = maximo(), v = parseInt(inp.value, 10) || 1;
      if (m !== Infinity && m > 0 && v > m) inp.value = m;
      if (mas) {
        var tope = m !== Infinity && (parseInt(inp.value, 10) || 1) >= m;
        mas.disabled = tope;
        if (tope) mas.title = 'No hay más stock disponible'; else mas.removeAttribute('title');
      }
    }
    if (inp) { inp.addEventListener('change', limita); inp.addEventListener('input', limita); limita(); }
    if (inp && txt) {
      var actualiza = function () {
        var n = Math.max(1, parseInt(inp.value, 10) || 1), uds = parseInt(txt.getAttribute('data-uds'), 10) || 1;
        if (txt.closest('button').disabled) return;
        txt.textContent = uds > 1 ? 'Añadir ' + n + (n === 1 ? ' pack' : ' packs') + ' (' + n * uds + ' uds)' : 'Añadir al carrito';
      };
      inp.addEventListener('change', actualiza);
      inp.addEventListener('input', actualiza);
    }
    raiz.querySelectorAll('[data-lob-mini]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = raiz.querySelector('[data-lob-principal]');
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = b.getAttribute('data-src');
        raiz.querySelectorAll('[data-lob-mini]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
    var form = raiz.querySelector('[data-lob-form]');
    if (form) {
      var ocupado = false;
      var unidad = (parseInt(txt && txt.getAttribute('data-uds'), 10) || 1) > 1 ? ['pack', 'packs'] : ['unidad', 'unidades'];
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (ocupado) return; // sin dobles clics
        ocupado = true;
        var msg = raiz.querySelector('[data-lob-msg]');
        var btn = form.querySelector('[type=submit]');
        var vid = form.querySelector('[name=id]').value;
        var pedida = Math.max(1, parseInt(inp.value, 10) || 1);
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var antes = 0;
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
          .then(function (c) { c.items.forEach(function (it) { if (String(it.variant_id) === String(vid)) antes += it.quantity; }); }, function () {})
          .then(function () { return anade(form, vid, pedida); })
          .then(function () {
            msg.className = 'lob-compra__msg lob-compra__msg--ok';
            msg.innerHTML = 'Añadido al carrito. <a href="/cart">Ver el carrito</a>';
            return null;
          }, function (err) { return err || new Error('No se ha podido añadir.'); })
          .then(function (err) {
            // Cantidad real ahora en el carrito: si Shopify ha recortado, aviso en ámbar con lo que de verdad se ha añadido
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
              var ahora = 0;
              c.items.forEach(function (it) { if (String(it.variant_id) === String(vid)) ahora += it.quantity; });
              var anadida = ahora - antes;
              var stock = parseInt(inp.getAttribute('data-stock'), 10);
              if (!isNaN(stock)) {
                inp.setAttribute('data-en-carrito', ahora);
                inp.setAttribute('max', Math.max(0, stock - ahora));
                inp.value = 1;
              }
              if (err) {
                if (anadida > 0) {
                  msg.className = 'lob-compra__msg lob-compra__msg--aviso';
                  var textoAviso = anadida === 1 ? 'Solo quedaba 1 ' + unidad[0] + ' disponible: hemos añadido 1.' :
                    'Solo quedaban ' + anadida + ' ' + unidad[1] + ' disponibles: hemos añadido ' + anadida + '.';
                  msg.innerHTML = textoAviso + ' <a href="/cart">Ver el carrito</a>';
                  // El mismo texto en la línea del cajón (en lugar del mensaje genérico de Shopify)
                  setTimeout(function () {
                    doc.querySelectorAll('cart-drawer-component .cart-items__table-row').forEach(function (row) {
                      if (String(row.dataset.key || '').indexOf(vid + ':') !== 0) return;
                      var tx = row.querySelector('.cart-item__error-text');
                      if (tx && tx.textContent.trim()) tx.textContent = textoAviso;
                    });
                  }, 400);
                } else if (!isNaN(stock) && ahora >= stock) {
                  msg.className = 'lob-compra__msg lob-compra__msg--aviso';
                  msg.textContent = 'Ya tiene en el carrito todas las unidades disponibles.';
                } else {
                  msg.className = 'lob-compra__msg lob-compra__msg--error';
                  msg.textContent = err.message || 'No se ha podido añadir.';
                }
              }
              var agotado = !isNaN(stock) && ahora >= stock;
              btn.disabled = agotado;
              if (agotado && txt) txt.textContent = 'Ya tiene en el carrito todas las unidades disponibles';
              limita();
            });
          })
          .catch(function () { btn.disabled = false; })
          .then(function () { ocupado = false; btn.removeAttribute('aria-busy'); });
      });
    }
    initTabs(raiz);
  }

  /* ---------------- carrito: ajustar al pedido mínimo ---------------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lob-ajustar]');
    if (!b) return;
    b.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-lob-ajustar'), 10) })
    }).then(function () { location.reload(); }).catch(function () { b.disabled = false; });
  });

  /* ---------------- carrito: «Finalizar pedido» (candado / listo) y validación del NIF en directo ---------------- */
  var ICO_CANDADO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var ICO_FLECHA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function marcaCampo(campo, estado, texto) {
    var caja = campo.closest('.lo-b2b__campo');
    if (!caja) return;
    caja.classList.toggle('lo-b2b__campo--ok', estado === 'ok');
    caja.classList.toggle('lo-b2b__campo--mal', estado === 'mal');
    var ico = caja.querySelector('.lo-b2b__estado');
    if (!ico) { ico = doc.createElement('span'); ico.className = 'lo-b2b__estado'; ico.setAttribute('aria-hidden', 'true'); campo.insertAdjacentElement('afterend', ico); }
    var nuevoIco = estado === 'ok' ? '✓' : estado === 'mal' ? '✕' : '';
    if (ico.textContent !== nuevoIco) ico.textContent = nuevoIco;
    if (texto !== undefined) {
      var err = doc.getElementById(campo.getAttribute('aria-describedby'));
      if (err && err.textContent !== texto) err.textContent = texto;
      campo.setAttribute('aria-invalid', estado === 'mal' ? 'true' : 'false');
    }
  }
  function estadoCarrito() {
    var btn = doc.querySelector('.cart-page #checkout');
    var falta = doc.querySelector('.cart-page [data-lo-falta]');
    var c = doc.querySelector('[data-lo-b2b]');
    if (!btn || !falta || !c) return;
    var nif = c.querySelector('[name="attributes[NIF]"]'), emp = c.querySelector('[name="attributes[Empresa]"]');
    var dec = c.querySelector('[data-lo-b2b-declaracion]');
    var h = window.loB2B, partes = [];
    var vNif = nif ? (h ? h.limpiar(nif.value) : nif.value.trim()) : '';
    var nifOk = !!vNif && (!h || h.documentoValido(vNif));
    if (!vNif) partes.push('el NIF/CIF de la empresa');
    else if (!nifOk) partes.push('un NIF/CIF válido (el que ha escrito no lo es)');
    if (!emp || emp.value.trim().length < 2) partes.push('la empresa o razón social');
    if (!dec || !dec.checked) partes.push('marque la declaración de compra como empresa');
    var ok = partes.length === 0;
    btn.classList.toggle('lo-incompleto', !ok);
    btn.classList.toggle('lo-listo', ok);
    var ico = btn.querySelector('.lo-ck-ico');
    if (!ico) { ico = doc.createElement('span'); ico.className = 'lo-ck-ico'; var bt = btn.querySelector('.button-text'); (bt || btn).insertAdjacentElement('afterbegin', ico); }
    var html = ok ? ICO_FLECHA : ICO_CANDADO;
    if (ico.getAttribute('data-estado') !== (ok ? 'ok' : 'no')) { ico.innerHTML = html; ico.setAttribute('data-estado', ok ? 'ok' : 'no'); }
    if (btn.getAttribute('aria-describedby') !== 'lo-falta-txt') btn.setAttribute('aria-describedby', 'lo-falta-txt');
    if (falta.id !== 'lo-falta-txt') falta.id = 'lo-falta-txt';
    if (falta.hidden) falta.hidden = false;
    falta.classList.toggle('lo-falta--ok', ok);
    var msg;
    if (ok) msg = 'Datos completos ✓ Ya puede finalizar el pedido.';
    else {
      var txt = partes.length > 1 ? partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1] : partes[0];
      msg = ('Para finalizar, indique ' + txt + '.').replace('indique marque', 'marque');
    }
    if (falta.textContent !== msg) falta.textContent = msg; // sin cambios no hay mutación (evita bucles del observador)
  }
  // NIF en directo: check verde si es válido, cruz roja y mensaje si no (a partir de 9 caracteres)
  function nifEnDirecto(campo) {
    var h = window.loB2B;
    if (!h) return;
    var v = h.limpiar(campo.value);
    if (!v) marcaCampo(campo, '', '');
    else if (h.documentoValido(v)) marcaCampo(campo, 'ok', '');
    else if (v.length >= 9) marcaCampo(campo, 'mal', 'El NIF/CIF no es válido. Compruebe las letras y números.');
    else marcaCampo(campo, '', '');
  }
  function empresaEnDirecto(campo) { marcaCampo(campo, campo.value.trim().length >= 2 ? 'ok' : ''); }
  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-lo-b2b]')) return;
    if (t.name === 'attributes[NIF]') nifEnDirecto(t);
    if (t.name === 'attributes[Empresa]') empresaEnDirecto(t);
  });
  doc.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('[data-lo-b2b]')) estadoCarrito(); });
  doc.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-lo-b2b]')) estadoCarrito(); });

  /* ---------------- carrito: «Guardar este carrito» (copiar enlace) ---------------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lo-copiar]');
    if (!b) return;
    var inp = doc.querySelector('[data-lo-enlace]'), est = doc.querySelector('[data-lo-copiado]');
    if (!inp) return;
    var ok = function () { if (est) est.textContent = 'Enlace copiado'; };
    var manual = function () {
      try { inp.focus(); inp.select(); ok(); if (!doc.execCommand('copy') && est) est.textContent = 'Seleccionado: pulse Ctrl+C para copiarlo'; }
      catch (err) { if (est) est.textContent = 'Seleccione el enlace y cópielo'; }
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(inp.value).then(ok, manual);
      else manual();
    } catch (err) { manual(); }
  });

  /* ---------------- carrito: restaurar desde /cart?restaurar=VARIANTE:CANTIDAD,… ---------------- */
  function restaurarCarrito() {
    var q;
    try { q = new URLSearchParams(location.search).get('restaurar'); } catch (e) { return; }
    if (!q || !doc.querySelector('.cart-page')) return;
    var items = [];
    q.split(',').forEach(function (par) {
      var m = /^(\d{1,20}):(\d{1,4})$/.exec(par.trim());
      if (m && +m[2] > 0) items.push({ id: Number(m[1]), quantity: Number(m[2]) });
    });
    var limpia = location.pathname;
    if (!items.length) { history.replaceState && history.replaceState(null, '', limpia); return; }
    var aviso = doc.createElement('p');
    aviso.className = 'lo-restaurando'; aviso.setAttribute('role', 'status');
    aviso.textContent = 'Cargando su carrito guardado…';
    var cab = doc.querySelector('.cart-page__title'); if (cab) cab.appendChild(aviso);
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var previo = [];
    // 12/10/2026: si el enlace guardado trae un producto que ya no existe, se devuelve el carrito que había (antes se quedaba vacío)
    fetch('/cart.js', { headers: json })
      .then(function (r) { return r.json(); })
      .then(function (c) { previo = (c.items || []).map(function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }; }); })
      .catch(function () {})
      .then(function () { return fetch('/cart/clear.js', { method: 'POST', headers: json }); })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); })
      .then(function () { location.replace(limpia); })
      .catch(function (err) {
        aviso.textContent = 'No hemos podido cargar algún producto del carrito guardado (' + err.message + '). Revise las líneas o escríbanos.' + (previo.length ? ' Se mantiene su carrito anterior.' : '');
        if (history.replaceState) history.replaceState(null, '', limpia);
        if (!previo.length) return;
        fetch('/cart/clear.js', { method: 'POST', headers: json })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: previo }) }); })
          .catch(function () {})
          .then(function () { setTimeout(function () { location.replace(limpia); }, 3000); });
      });
  }
  window.lomRestaurar = restaurarCarrito;

  /* ---------------- carrito: Intro en la cantidad = aplicar la cantidad, no enviar el formulario ---------------- */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('input[name="updates[]"]')) return;
    e.preventDefault();
    e.target.blur();
  }, true);

  /* ---------------- orden (colección y búsqueda) ---------------- */
  function initOrden(s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  }

  function arranca() {
    doc.querySelectorAll('[data-lob-tabs]').forEach(initTabs);
    doc.querySelectorAll('[data-lob-ficha]').forEach(initFicha);
    doc.querySelectorAll('[data-lob-compat]').forEach(initCompat);
    doc.querySelectorAll('[data-lob-cxm]').forEach(initCxm);
    doc.querySelectorAll('[data-lob-orden]').forEach(initOrden);
    restaurarCarrito();
    estadoCarrito();
    (function () { var c = doc.querySelector('[data-lo-b2b]'); if (!c) return;
      var n = c.querySelector('[name="attributes[NIF]"]'), m = c.querySelector('[name="attributes[Empresa]"]');
      if (n && n.value) nifEnDirecto(n); if (m && m.value) empresaEnDirecto(m); })();
    if (window.MutationObserver) { var cp = doc.querySelector('.cart-page'); if (cp) new MutationObserver(function () { estadoCarrito(); }).observe(cp, { childList: true, subtree: true }); }
    var f = doc.querySelector('[data-lob-filtros]');
    if (f && window.matchMedia('(max-width: 989px)').matches) f.removeAttribute('open');
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
